/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ISHONCH Platform API
 * Login: POST /api/v1/auth/otp → code (dev: in the app log) → POST /api/v1/auth/otp/verify → paste response_data.as_access_token into Authorize. Every response is the company envelope (ADR-0007).
 * OpenAPI spec version: v1
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  ContractResponse,
  MyContractsParams,
  SummaryResponse,
} from "../iSHONCHPlatformAPI.schemas";

import { httpRequest } from "../../http";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getMyContractsUrl = (params?: MyContractsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/cabinet/contracts?${stringifiedParams}`
    : `/api/v1/cabinet/contracts`;
};

export const myContracts = async (
  params?: MyContractsParams,
  options?: Parameters<typeof httpRequest>[1],
): Promise<ContractResponse[]> => {
  return httpRequest<ContractResponse[]>(getMyContractsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getMyContractsQueryKey = (params?: MyContractsParams) => {
  return [`/api/v1/cabinet/contracts`, ...(params ? [params] : [])] as const;
};

export const getMyContractsQueryOptions = <
  TData = Awaited<ReturnType<typeof myContracts>>,
  TError = unknown,
>(
  params?: MyContractsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof myContracts>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMyContractsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof myContracts>>> = ({ signal }) =>
    myContracts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof myContracts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type MyContractsQueryResult = NonNullable<Awaited<ReturnType<typeof myContracts>>>;
export type MyContractsQueryError = unknown;

export function useMyContracts<TData = Awaited<ReturnType<typeof myContracts>>, TError = unknown>(
  params: undefined | MyContractsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof myContracts>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof myContracts>>,
          TError,
          Awaited<ReturnType<typeof myContracts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMyContracts<TData = Awaited<ReturnType<typeof myContracts>>, TError = unknown>(
  params?: MyContractsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof myContracts>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof myContracts>>,
          TError,
          Awaited<ReturnType<typeof myContracts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMyContracts<TData = Awaited<ReturnType<typeof myContracts>>, TError = unknown>(
  params?: MyContractsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof myContracts>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useMyContracts<TData = Awaited<ReturnType<typeof myContracts>>, TError = unknown>(
  params?: MyContractsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof myContracts>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMyContractsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getContractsSummaryUrl = () => {
  return `/api/v1/cabinet/contracts/summary`;
};

export const contractsSummary = async (
  options?: Parameters<typeof httpRequest>[1],
): Promise<SummaryResponse> => {
  return httpRequest<SummaryResponse>(getContractsSummaryUrl(), {
    ...options,
    method: "GET",
  });
};

export const getContractsSummaryQueryKey = () => {
  return [`/api/v1/cabinet/contracts/summary`] as const;
};

export const getContractsSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof contractsSummary>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsSummary>>, TError, TData>>;
  request?: SecondParameter<typeof httpRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getContractsSummaryQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof contractsSummary>>> = ({ signal }) =>
    contractsSummary({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof contractsSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ContractsSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof contractsSummary>>>;
export type ContractsSummaryQueryError = unknown;

export function useContractsSummary<
  TData = Awaited<ReturnType<typeof contractsSummary>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsSummary>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsSummary>>,
          TError,
          Awaited<ReturnType<typeof contractsSummary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useContractsSummary<
  TData = Awaited<ReturnType<typeof contractsSummary>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsSummary>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsSummary>>,
          TError,
          Awaited<ReturnType<typeof contractsSummary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useContractsSummary<
  TData = Awaited<ReturnType<typeof contractsSummary>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsSummary>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useContractsSummary<
  TData = Awaited<ReturnType<typeof contractsSummary>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsSummary>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getContractsSummaryQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
